import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, MapPin, Phone, Mail } from 'lucide-react';
import { Separator } from './ui/separator';

export const Footer = () => {
  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Shield className="h-6 w-6 text-primary" />
              <span className="text-lg font-semibold">Green Flux</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Advanced security solutions for banks, government facilities, and critical infrastructure since 2020.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Projects
                </Link>
              </li>
            </ul>
          </div>

          {/* London Office */}
          <div>
            <h4 className="text-sm font-semibold mb-4">London Office</h4>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4 mt-0.5 text-accent flex-shrink-0" />
                <span>14 Canary Wharf<br />London, UK</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Phone className="h-4 w-4 text-accent" />
                <span>+44 7494 695344</span>
              </li>
            </ul>
          </div>

          {/* New York Office */}
          <div>
            <h4 className="text-sm font-semibold mb-4">New York Office</h4>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4 mt-0.5 text-accent flex-shrink-0" />
                <span>280 Hudson Street<br />NY, USA</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Phone className="h-4 w-4 text-accent" />
                <span>+1 646 391 5932</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Green Flux Security System. All rights reserved.
          </p>
          <div className="flex items-center space-x-2">
            <Mail className="h-4 w-4 text-accent" />
            <a href="mailto:info@greenfluxsystems.org" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              info@greenfluxsystems.org
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
